export const CONTACT_INFO = {
  EMAIL: "fengshangwuqi@gmail.com",
};
